<ion-app>
  <app-global-spinner/>
  <ion-router-outlet></ion-router-outlet>
</ion-app>